module.exports = __webpack_public_path__ + "static/media/20ECE12.f44e7988.jpg";